module.exports = __webpack_public_path__ + "resources/img/certi_iso_iec_27017.51316a4484489b31d4e82ca8068c2b89.png";